(function () {
    'use strict';

    a3_cabin_reports.controller('ReminderModalCtrl', ReminderModalCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name ReminderModalCtrl
    * @description 
    * Warning Modal about acknowledge schedule changes and medical & passport expiries
    * @ngInject
    */
    function ReminderModalCtrl(showExpiriesReminder, showSubmissionDeadlineReminder, showScheduleChangesReminder, ExpiriesFactory,  RequestFactory, ScheduleAcknowledgeFactory, $scope, $uibModalInstance) {

        $scope.cancel = cancel;
        //from parent view:
        $scope.showScheduleChangesReminder = showScheduleChangesReminder;
        $scope.showExpiriesReminder = showExpiriesReminder;
        $scope.showSubmissionDeadlineReminder = showSubmissionDeadlineReminder;
        $scope.expiryList = ExpiriesFactory.getCrewExpiriesFromStorage();
        $scope.submissionDeadline = RequestFactory.getSubmissionDeadlineDateFromStorage();
        $scope.daysDiff = daysDiff;

        /**
         * Calculates days left
         * @return {string} usage
         */
        function daysDiff(date) {
            var today = moment().startOf('day');
            var expiryDate = moment(date)

            return expiryDate.diff(today, 'days');
        }

        /**
        * Closes modal
        * @memberof ProposalInfoModalCtr
        */
        function cancel() {
            if ($scope.showScheduleChangesReminder) {
                ScheduleAcknowledgeFactory.updateShowScheduleChangesModal(false);
            }
            if ($scope.showExpiriesReminder) {
                ExpiriesFactory.updateShowExpiriesModal(false);
            }
            if ($scope.showSubmissionDeadlineReminder) {
                RequestFactory.updateShowSubmissionDeadlineModal(false);
            }

            $uibModalInstance.close('cancel');
        }
    }

})();